













































































import Vue from "vue";

export default Vue.extend({
  name: "HelloWorld",

  data: () => ({
    firstExample:
      '<v-draggable-treeview group="test" v-model="items"></v-draggable-treeview>',
    secondExample:
      '<v-draggable-treeview v-model="items"></v-draggable-treeview>',
    thirdExample:
      '            <v-draggable-treeview v-model="items" group="hoge">\n' +
      '              <template v-slot:prepend="{ item }">\n' +
      "                <v-icon>mdi-file</v-icon>\n" +
      "              </template>\n" +
      '              <template v-slot:label="{ item }">\n' +
      '                <span class="primary--text">{{ item.name }}</span>\n' +
      "              </template>\n" +
      '              <template v-slot:append="{ item }">\n' +
      "                <template\n" +
      '                  v-if="item.children != null && item.children.length > 0"\n' +
      "                >\n" +
      "                  has {{ item.children.length }} children\n" +
      "                </template>\n" +
      "              </template>\n" +
      "            </v-draggable-treeview>",
    items: [
      {
        id: 1,
        name: "Central League",
        children: [
          { id: 101, name: "Dragons" },
          { id: 102, name: "Tigers" }
        ]
      },
      {
        id: 2,
        name: "Pacific League",
        children: [
          {
            id: 201,
            name: "Lions",
            children: [
              { id: 203, name: "Lions Minor" },
              {
                id: 204,
                name: "Lions third",
                children: [{ id: 2041, name: "Lions Minor Second" }]
              }
            ]
          }
        ]
      }
    ]
  })
});
